<template>
<!-- 我要申请(名称-描述-机构)页面(政策、第三方服务) -->
<div class="policyApplyView">
            <el-form   label-width="140px" :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
                <!-- 名称 不需要搜索-直接上一页传过来 prop="policyName" 仅展示-不可编辑 -->
                <el-form-item :label="detailType===1?'政策名称':detailType===4?'服务名称':''" class="fileProp">
                    <p class="policyNameCss">{{ruleForm.policyName}}</p>
                </el-form-item>
                <!-- 需求描述 -->
                <el-form-item label="描述" prop="content" class="fileProp">
                    <el-input placeholder="请输入详细描述" v-model="ruleForm.content" :rows="6" :maxlength="300" :show-word-limit="true" type="textarea"> </el-input>
                </el-form-item>
                 <!-- 选择第三方服务机构 -->
                <el-form-item label="选择第三方服务机构(选填)" 
                                v-if="policydata!=null&policydata.length>0">
                    <lp-policy-apply-list :policydata='policydata' @selectID="mechanismIdAction"></lp-policy-apply-list>
                </el-form-item>
                <div v-else></div>
                <!-- 条款 -- 只有政策的服务申请有这个条款！,detailType===1代表是政策-->
                <el-form-item label="" prop="checked" v-if="detailType===1">
                    <el-checkbox v-model="ruleForm.checked">我已阅读并同意<span class="policyTerms" @click.stop="policyTermsAction">《政策申报条款》</span></el-checkbox>
                </el-form-item>

                <el-form-item label="">
                    <el-button @click="submitForm('ruleForm')" type="primary" >立即申请</el-button>
                    <el-button @click="cancle" >&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>
                </el-form-item>

            </el-form>
        </div>     
</template>

<script>

    export default {
        name: "lp-policy-apply",
         data() {
                //  手机验证
                const  valiPhone = (rule, value, callback) => {
                    if (!/^[0-9][0-9]\d{9}$/.test(value)) {
                        callback(new Error('请输入正确的手机号'));
                    } else {
                        callback();
                    }
                };
                // 条款同意验证
                const  valiChecked = (rule, value, callback) => {
                    if (value===false) {
                        callback(new Error('请先阅读并同意有关条款'));
                    } else {
                        callback();
                    }
                };
                const { query:{type,title},params:{code:id} }=this.$route;

                return {
                    serverOrderType:1,//服务订单类型:1申请  2咨询  3预审
                    detailType:parseInt(type),//type=1政策，type=4服务
                    // 第三方服务机构列表
                    policydata:[],
                    //第三方机构选择id
                    mechanismId:'',
                    ruleForm:{
                        policyName:title,//政策名称
                        content:'',//描述
                        checked:false,//条款
                    },
                    rules: { 
                        policyName: [
                            { required: true, message: '请输入政策名称', trigger: 'blur' }
                        ],
                        content: [
                            { required: true, message: '请输入描述', trigger: 'blur' }
                        ],
                        checked: [
                            { validator: valiChecked, trigger: 'blur' }
                        ],  
                    },

                };
        },
        // created(){//目前这个页面只做申请页面！
        //     const { query:{orderType} } =this.$route;
        //     this.serverOrderType=orderType;
        // },
        mounted() {
             //初始化ruleForm数据
            this.ruleForm=this.initForm();
            //获取第三方服务机构列表
            this.getServiceListData();
             
        },
        methods: {
            /*
            初始化数据
            */
            initForm(){
                const { query:{type,title},params:{code:id} }=this.$route;
                return {
                        type:'',//需求类型
                        policyName:title,//政策名称
                        content:'',//描述
                        checked:false,//条款
                        fileList:[]//图片
                }
            },

            /*
            政策申报条款-跳转
            */ 
            policyTermsAction(){
                // 防止表单信息消失-跳转新页面查看申报条款
                let routeData = this.$router.resolve({
                    path:"/policyTerms"
                });
                window.open(routeData.href, '_blank');
            },

            /*
            操作
            */
            // 移除该表单项的校验结果 // this.$refs['ruleForm'].clearValidate();
            // 取消-返回上一页
            cancle() {
                window.history.go(-1);
            },
            //立即提交
            submitForm(formName) {
                const { query:{type,title},params:{code:id} }=this.$route;
                //提交接口
                const {ruleForm,mechanismId,typeList,serverOrderType}=this;
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        /*申请*/
                        var params={
                            companyId:localStorage.getItem('companyId')?localStorage.getItem('companyId'):'',
                            policyId:type==1?id:null,//详情-政策id
                            thirdServerId:type==4?id:null,//详情-服务id
                            institutionId:mechanismId?mechanismId:null,//第三方机构id（非必填）
                            remark:ruleForm.content,//描述
                            serverOrderType:1,//服务订单类型:1申请  2咨询  3预审
                            // type=1政策，type=4服务，
                            serverOrderSource:type==1?1:type==4?2:'',// 服务订单来源:1政策!  2第三方服务!  3服务(机构)  4其它
                            name:title//标题
                        }
                        const res= await this.$Apis.getPolicyTermsList(params);
                        const { code,data,msg }=res;
                        if(code==1){
                            this.$message.success('提交成功，请到企业管理中心查看申请进度');
                            this.$router.go(-1);
                        }
                    }
                })
            },
            /*
            第三方服务
            */
             // 获取机构列表
            async getServiceListData(){  
                 const { query:{type,title},params:{code:routecode} }=this.$route;
                // type=1政策，type=4服务
                // let parkId =this.$store.state.parkId
                 let params={
                        // serverType:null,//全部
                        // name:null,
                        // page:1,
                        // pagesize:100,
                        // parkId:parkId,
                        type:type==1?'1':(type==4?'2':''),//1政策解读  2第三方服务
                        policyId:routecode
                    }
                const res=await this.$Apis.getPolicyInstitutionsList(params);
                const {code,msg,data }=res;
                var listArr=[]
                for(var i=0;i<data.length;i++){
                    var item =data[i]
                    let dataDic={
                        id:item.id,
                        logo:item.logo,
                        mechanismName:item.institutionName,
                        sel:false,
                        mechanismUserId:item.mechanismUserId,
                    }
                    listArr.push(dataDic)
                }
                 this.policydata=listArr;
            }, 

            // // 选择第三方机构的id
            mechanismIdAction(data){
                 // 原来是选中的-现在要取消选中
                    var policyTypeList=this.policydata;
                   var itemType= policyTypeList[data.index]
                if(itemType.sel===true){
                   itemType.sel=false
                   this.policydata=policyTypeList;
                //    当前机构id要置空
                    this.mechanismId=''
                }else{
                    // 原来是未选中-现在要选中
                    for(var i=0;i<this.policydata.length;i++){
                        var item =this.policydata[i]
                        item.sel=false
                        if(i==data.index){
                            item.sel=true;
                        }
                    } 
                    this.mechanismId=data.id;
                }
            },
        }
    }
</script>


<style lang="less" scoped>
.policyApplyView{
        background-color: #fff;
        width: 100%;
        padding: 50px 38px 28px 38px;
        box-sizing: border-box;
        // flex: 1;
        flex-grow: 1;
        .ruleForm{
            // /deep/ .el-form-item__label:before {
            //     display: none;
            // }
            .el-input,
            .el-select,
            .el-date-editor{
                width: 200px;
                height: 36px;
                line-height: 36px;
                /deep/ .el-input__inner{
                    height: 36px;
                    line-height: 36px;
                }
                /deep/ .el-input-group__append {
                    height: 34px;
                    line-height: 34px;
                    box-sizing: border-box;
                }
            }
            .el-textarea,.upload-demo{
                width: 500px;
            } 
        }
        // 指定模块添加星号
        .el-form{
            // 星号都不要，选填加括号
            /deep/ .fileProp{
                    .el-form-item__label::before{
                        content: ''!important;
                    }
                }
            // /deep/ .fileProp{
            //         .el-form-item__label::before{
            //             content: '*';
            //             color: #F56C6C;
            //             margin-right: 4px;
            //         }
            //     }
        }
        .policyNameCss{
            // height: 40px;
            // line-height: 40px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            // color: #333333;
        }
            
           .el-form-item__label:before {
                content: '*';
                color: #F56C6C;
                margin-right: 4px;
            }
             // 图片上传
            .imgList{
                display: flex;
                flex-wrap: wrap;
                img{
                    width: 148px;
                    height: 148px;
                    margin-right: 20px;
                    border: 1px dashed #d9d9d9;
                    box-sizing: border-box;
                }
            }
            .policyTerms{
                color: @hoverDefaultColor;
            }
    }

</style>


// WEBPACK FOOTER //
// src/components/policyapply/index.vue